<template>
  <div>
    <div v-if="valid_items"
         class="accordion">
      <div v-for="(item, index) in items"
           class="accordion__item">
        <div class="accordion__item-title"
             :class="{no_border: accordion_border_unset}"
             @click="changeIndexOpened(index)">
          <slot name="title_img"></slot>
          <span :class="{has_img: has_img_title}">{{ item.title }}</span>
          <div class="accordion__item-title-btn" :class="{active: active === index}"></div>
        </div>
        <slide-up-down :active="active === index">
          <div class="accordion__item-content"
               :class="{no_border: accordion_border_unset}">
            <html-block v-if="content_as_html" :content="item.content"/>
            <template v-else>{{ item.content }}</template>
            <div v-if="item.img">
              <img class="w_50 mx-auto d-block" :src="item.img" :alt="item.img_alt || 'Accordion image'"/>
            </div>
          </div>
        </slide-up-down>
      </div>
    </div>
  </div>
</template>

<script>

import SlideUpDown from "../SlideUpDown";
import HtmlBlock from "../../small_parts/HtmlBlock";
export default {
  name: 'Accordion',
  components: {HtmlBlock, SlideUpDown},
  props: {
    items: {
      required: true,
      type: Array,
      default: () => []
    },
    title_img: {
      type: String,
      default: ''
    },
    content_as_html: {
      type: Boolean,
      default: false
    },
    opened: {
      type: Number,
      default: -1
    },
    accordion_border_unset: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: -1,
    }
  },
  created() {
    this.active = this.opened
  },
  computed: {
    has_img_title() {
      return !!this.$scopedSlots.title_img
    },
    valid_items() {
      return this.items.every(el => el.title && el.content)
    }
  },
  methods: {
    changeIndexOpened(index) {
      if (index === this.active) {
        this.active = -1
        return
      }
      this.active = index
    }
  },
  watch: {
    opened(new_val) {
      setTimeout(()  => {
        this.active = new_val
      })
    }
  }
}
</script>
